import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { SectionQuestion as SectionQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    paddingTop: '24px',
    paddingBottom: '24px',
  },
  title: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
    color: '#616161',
  },
  description: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#605e5c',
  },
});

interface SectionQuestionViewProps {
  question: SectionQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const SectionQuestionView: React.FC<SectionQuestionViewProps> = ({
  question,
  onClick,
}) => {
  const styles = useStyles();

  return (
    <div 
      className={styles.container}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      data-question-view
    >
      <div className={styles.title}>
        {question.title}
      </div>
      {question.description && (
        <div className={styles.description}>
          {question.description}
        </div>
      )}
    </div>
  );
};
